import { render, staticRenderFns } from "./study-folder.vue?vue&type=template&id=6bb2bb52&scoped=true&"
import script from "./study-folder.vue?vue&type=script&lang=ts&"
export * from "./study-folder.vue?vue&type=script&lang=ts&"
import style0 from "./study-folder.vue?vue&type=style&index=0&id=6bb2bb52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb2bb52",
  null
  
)

export default component.exports